import State from '../core/State';
import Region from '../entity/Region';

export const setRegion = (region: Region) => (state: State): State => ({
  ...state,
  region,
});
